/**
 * Features for product type ciril.
 */
export enum LicenseCirilFeature {
  PRINTED_REPORT_STEM = 'printed_report_stem',
  ONLINE_REPORT_STEM = 'online_report_stem'
}
